import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { isNullOrEmpty } from "../../../../../_helpers";

import CourseBuilderSidebar from "./CourseBuilderSidebar";
import SaveDraft from "@components/Overlay/SaveDraftOverlay/SaveDraftOverlay";
import CourseBuilderMain from "./CourseBuilderComponents/CourseBuilderMain";

import "./CourseBuilder.scss";
import axiosInstance from "../../../../../axios";

import CourseQuestion from "./CourseBuilderComponents/CourseQuestion";
import CourseBuilderFooter from "./CourseBuilderComponents/CourseBuilderFooter";

import CourseCategory from "./CourseBuilderComponents/CourseCategory";
import CourseBuilderTopbar from "./CourseBuilderComponents/CourseBuilderTopbar";
import CourseSubmit from "./CourseBuilderComponents/Coursesubmit";
import { useLocation, useNavigate } from "react-router-dom";

const TOTAL_SLIDES = 22;
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const CourseBuilder = (props) => {
  //console.log("propssss", props)
  // edit state mapper
  const location = useLocation();
  const [storedSession, setStordSession] = useState(
    window.sessionStorage.getItem("WebinarLiveStatus")
  );

  const [createBundle, setCreateBundle] = useState(
    window.sessionStorage.getItem("CourseStatus")
  );

  const { isExperienced } = useSelector((state) => state?.users?.user);
  const [current, setCurrent] = useState(
    createBundle || props?.location?.courseStatus ? 5 : isExperienced ? 4 : 0
  );
  //console.log("currentcurrentcurrent", current);
  const navigate = useNavigate();
  const [saveDraft, setSaveDraft] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState([]);
  const [quizValidateMsg, setQuizValidateMsg] = useState(false);
  const [progressCount, setProgressCount] = useState(null);
  const [formValues, setFormValues] = useState({
    teacherExperience: `${isExperienced ? "teacherExperience" : ""}`,
    experienceWithVideo: `${isExperienced ? "experienceWithVideo" : ""}`,
    courseReadiness: `${isExperienced ? "courseReadiness" : ""}`,
    courseType: "",
    liveWebinarCourse: "",
    courseName: "",
    category: "",
    subCategory: "",
    createBundle: props?.location?.courseSelected
      ? props?.location?.courseSelected
      : [],
    multipleCheckBox: [],
    IsAdult: "0",
    goals: [],
    courseOneLiner: "",
    courseOutDescription: null,
    preRequisites: [],
    description: null,
    faqs: [],
    syllabus: [],
    level: "",
    language: "",
    duration: "",
    imageFiles: [],
    videoFiles: [],
    scheduleEvent: "",
    courseSections: [],
    isFree: false,
    currency: "INR",
    enrollmentFee: 0,
    promotionalOffer: false,
    promotionalCode: "",
    discountPercent: "",
    status: 1,
    courseDate: "",
  });
  const [quizResponse, setQuizResponse] = useState();
  const [quizStatus, setQuizStatus] = useState();
  const [quizCreation, setQuizCreation] = useState({
    name: "",
    guidelines: "",
    id: "",
    questions: [
      {
        question: null,
        time: "",
        type: null,
        answers: [{ answer: "", isRight: false }],
      },
    ],
  });
  const [errors, setErrors] = useState({
    goals: [],
    preRequisites: [],
    faqs: [],
    syllabus: [],
    courseSections: [],
  });

  const [coursebuilderToggle, setcoursebuilderToggle] = useState(true);

  const [windowDimension, setWindowDimension] = useState(window.innerWidth);
  const detectSize = () => {
    setWindowDimension(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    if (windowDimension <= 900) {
      setcoursebuilderToggle(false);
    } else {
      setcoursebuilderToggle(true);
    }
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);

  const ref = useRef(null);
  const next = () => {
    if (current >= TOTAL_SLIDES) {
      return;
    } else if (createBundle !== "createBundle") {
      setCurrent(current + 1);
      switch (current + 1) {
        case 8:
          if (formValues.goals.length === 0) {
            setFormValues({
              ...formValues,
              goals: [{ name: "" }, { name: "" }],
            });
          }
          break;
        case 10:
          if (formValues.preRequisites.length === 0) {
            setFormValues({
              ...formValues,
              preRequisites: [{ name: "" }],
            });
          }
          break;
        case 12:
          if (formValues.faqs.length === 0) {
            setFormValues({
              ...formValues,
              faqs: [{ question: "", answer: "" }],
            });
          }
          break;
        case 13:
          if (formValues.syllabus.length === 0) {
            setFormValues({
              ...formValues,
              syllabus: [{ name: "" }],
            });
          }
          break;
        case 17:
          if (formValues.courseSections.length === 0) {
            setFormValues({
              ...formValues,
              courseSections: [
                {
                  name: "",
                  videoLink: "",
                  description: null,
                  files: [],
                },
              ],
            });
          }
          break;
        default:
          break;
      }
    }
    setCurrent(current + 1);
    switch (current + 1) {
      case 8:
        if (formValues.goals.length === 0) {
          setFormValues({
            ...formValues,
            goals: [{ name: "" }, { name: "" }],
          });
        }
        break;
      case 10:
        if (formValues.preRequisites.length === 0) {
          setFormValues({
            ...formValues,
            preRequisites: [{ name: "" }],
          });
        }
        break;
      case 12:
        if (formValues.faqs.length === 0) {
          setFormValues({
            ...formValues,
            faqs: [{ question: "", answer: "" }],
          });
        }
        break;
      case 16:
        if (formValues.courseSections.length === 0) {
          setFormValues({
            ...formValues,
            courseSections: [
              {
                name: "",
                videoLink: "",
                description: null,
                files: [],
                scroms: [],
              },
            ],
          });
        }
        break;
      default:
        break;
    }
  };

  const prev = () => {
    if (current === 0) return;
    else if (current === 5 && createBundle === "createBundle")
      return navigate("/dashboard/CreateBundle");
    else setCurrent(current - 1);
  };

  useEffect(() => {
    if (location.state) {
      setCurrent(location.state.current);
      switch (location.state.current) {
        case 8:
          if (formValues.goals.length === 0) {
            setFormValues({
              ...formValues,
              goals: [{ name: "" }, { name: "" }],
            });
          }
          break;
        default:
          break;
      }
    }
  }, [location?.state]);

  useEffect(() => {
    ref.current.style.transition = "all 0.2s ease-in-out";
    ref.current.style.transform = `translateX(-${current}00%)`;
  }, [current]);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const closeHandler = () => {
    setSubmit(false);
  };

  const validateAll = () => {
    return [...Array(10).keys()].reduce((result, item, index, array) => {
      if (!validate(item)) {
        array.splice(1);
        return false;
      }
      return true;
    }, false);
  };

  const handleInputChange = (index, name, value, accessor = null) => {
    let clonedValues = [...formValues[name]];
    setFormValues({
      ...formValues,
      [name]: bindFormValues(index, value, clonedValues, accessor),
    });
  };

  const bindFormValues = (index, value, items, accessor = null) => {
    accessor ? (items[index][accessor] = value) : (items[index] = value);
    return items;
  };
  const validate = (index) => {
    if (storedSession === "liveCourse") {
      switch (index) {
        case 4:
          return isNullOrEmpty(formValues.courseType);
        case 5:
          return isNullOrEmpty(formValues.liveWebinarCourse);
        case 6:
          return formValues.courseName !== "" && !error;
        case 7:
          return isNullOrEmpty(formValues.category);
        case 8:
          return true;
        case 9:
          return formValues.description !== null ? true : false;
        case 10:
          return isNullOrEmpty(formValues.level && formValues.language);
        case 11:
          return formValues.imageFiles.length > 0 ? true : false;
        case 12:
          return (
            formValues.isFree ||
            (formValues.enrollmentFee !== "" &&
              formValues.enrollmentFee != "0" &&
              (formValues.promotionalOffer
                ? isNullOrEmpty(formValues.promotionalCode)
                : true))
          );
        case 13:
          return isNullOrEmpty(formValues.scheduleEvent);
        case 14:
          return true;
        default:
          return false;
      }
    }
    if (createBundle === "createBundle") {
      switch (index) {
        case 5:
          return formValues.courseName !== "" && !error;
        case 6:
          if (formValues.multipleCheckBox.length > 0) {
            return true;
          } else {
            return false;
          }
        case 7:
          return true;
        case 8:
          return true;
        case 9:
          if (current >= 9) {
            return true;
          }
        case 10:
          if (current >= 10) {
            return true;
          }
        case 11:
          return formValues.description !== null ? true : false;
        case 12:
          if (current >= 12) {
            return true;
          }
        case 13:
          return isNullOrEmpty(formValues.level && formValues.language);
        case 14:
          return formValues.imageFiles.length > 0 ? true : false;
        case 15:
          if (current >= 15) {
            return true;
          }
        case 16:
          return (
            formValues.isFree ||
            (formValues.enrollmentFee !== "" &&
              formValues.enrollmentFee != "0" &&
              (formValues.promotionalOffer
                ? isNullOrEmpty(formValues.promotionalCode)
                : true))
          );
        default:
          return false;
      }
    } else
      switch (index) {
        case 0:
          return isNullOrEmpty(formValues.teacherExperience);
        case 1:
          return isNullOrEmpty(formValues.experienceWithVideo);
        case 2:
          return isNullOrEmpty(formValues.courseReadiness);
        case 3:
          return true;
        case 4:
          return isNullOrEmpty(formValues.courseType);
        case 5:
          return formValues.courseName !== "" && !error;
        case 6:
          return isNullOrEmpty(formValues.category);
        case 7:
          return true;
        case 8:
          return (
            formValues.goals.every((item) => item.name.trim() !== "") &&
            formValues.goals.length > 0 &&
            errors.goals.every((item) => item.valid)
          );
        case 9:
          if (current >= 9 || isNullOrEmpty(formValues.courseOneLiner))
            return true;
        case 10:
          if (current >= 10 || isNullOrEmpty(formValues.courseOutDescription))
            return true;

        case 11:
          if (
            current >= 11 ||
            (formValues.preRequisites.every(
              (item) => item.name.trim() !== ""
            ) &&
              formValues.preRequisites.length > 0 &&
              errors.preRequisites.every((item) => item.valid))
          )
            return true;
        case 12:
          return formValues.description !== null ? true : false;
        case 13:
          return (
            formValues.faqs.every((item) =>
              Object.values(item).every((v) => v.trim() !== "")
            ) && formValues.faqs.length > 0
          );

        case 14:
          return (
            formValues.syllabus.every((item) => item.name.trim() !== "") &&
            formValues.syllabus.length > 0 &&
            errors.syllabus.every((item) => item.valid)
          );
        case 15:
          return isNullOrEmpty(formValues.level && formValues.language);
        case 16:
          return formValues.imageFiles.length > 0 ? true : false;
        case 17:
          return formValues.videoFiles.length > 0 ? true : false;
        case 18: {
          return (
            formValues.courseSections
              .map(({ name, description }) => ({
                name,
                // description: description ? JSON.stringify(description) : null,
              }))
              .every((item) =>
                Object.values(item).every((value) => isNullOrEmpty(value))
              ) && formValues.courseSections.length > 0
          );
        }

        case 19:
          return (
            formValues.isFree ||
            (formValues.enrollmentFee !== "" &&
              formValues.enrollmentFee != "0" &&
              (formValues.promotionalOffer
                ? isNullOrEmpty(formValues.promotionalCode)
                : true))
          );
        case 20:
          return true;
        case 21:
          return quizCreation?.questions?.every(
            (item) =>
              item?.question !== null &&
              item?.answers?.every((data) => data?.answer !== "")
          );

        case 22:
          return true;
        default:
          return false;
      }
  };

  const canAddMoreFields = (
    formData,
    errors,
    property,
    max,
    isNested = null
  ) => {
    let isValid = isNested
      ? formData[property].every((item) =>
        Object.values(item).every((value) => isNullOrEmpty(value))
      )
      : formData[property].every((item) => isNullOrEmpty(item));
    return (
      isValid &&
      formData[property].length < max &&
      errors[property].every((item) => item.valid)
    );
  };

  useEffect(() => {
    if (formValues.courseType === "liveCourse") {
      window.sessionStorage.setItem("WebinarLiveStatus", "liveCourse");
      setStordSession("liveCourse");
    } else if (formValues.courseType === "onDemand") {
      window.sessionStorage.setItem("WebinarLiveStatus", "onDemand");
      setStordSession("onDemand");
    } else if (props?.location?.courseStatus === "createBundle") {
      window.sessionStorage.setItem("CourseStatus", "createBundle");
      setCreateBundle("createBundle");
    }
  }, [formValues.courseType]);

  const addFormFields = (
    event,
    property,
    max,
    prevState,
    errors,
    value = "",
    accessor = null
  ) => {
    event.preventDefault();

    if (canAddMoreFields(prevState, errors, property, max, accessor)) {
      setFormValues({
        ...formValues,
        [property]: [...formValues[property], value],
      });
    }
  };

  const isDuplicate = (input, items) =>
    items.some(
      (item) => item.name.toLowerCase() === input.trim().toLowerCase()
    );

  const validateDuplicateText = (value, index, property, items) => {
    if (isNullOrEmpty(value) && isDuplicate(value, items)) {
      setErrors({
        ...errors,
        [property]:
          errors[property].filter((item) => item.id === index).length > 0
            ? errors[property]
            : [...errors[property], { id: index, vaild: false }],
      });
    } else {
      setErrors({
        ...errors,
        [property]: [...errors[property].filter((item) => item.id !== index)],
      });
    }
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    setFormValues({ ...formValues, [property]: newFormValues });
  };

  const handleExit = (event) => {
    event.preventDefault();
    sessionStorage.clear();
    setSaveDraft((state) => !state);
  };

  const convertDesciptionToHtml = (sections, courseId) => {
    let mappedSections = [];
    for (var section of sections) {
      let mappedfiles = section.files;
      mappedSections.push({
        name: section.name,
        videoLink: section.videoLink,
        courseId: courseId,
        description: section.description
          ? section.description
          : section.description,
        files: mappedfiles,
        scroms: section.scroms,
      });
    }
    return mappedSections;
  };

  const config = {
    onUploadProgress: (progressEvent) => {
      setProgressCount((progressEvent.loaded / progressEvent.total) * 100);
    },
  };

  const createUpdateCourse = async (
    createCourse,
    body,
    config,
    headers,
    courseId
  ) => {
    try {
      if (createCourse) {
        if (createBundle !== "createBundle") {
          return await axiosInstance.post("/course", body, config, headers);
        } else {
          return await axiosInstance.post(
            `${REACT_APP_LOGIN_API_BASEURL}/v2/bundles`,
            body,
            config,
            headers
          );
        }
      } else {
        if (createBundle !== "createBundle") {
          return await axiosInstance.put(`/course/${courseId}`, body, config, headers);
        } else {
          return await axiosInstance.put(
            `${REACT_APP_LOGIN_API_BASEURL}/v2/bundles/${courseId}`,
            body,
            config,
            headers
          );
        }
      }
    } catch (error) {
      console.error("Error in createUpdateCourse:", error);
      throw error;
    }
  };

  const getRequestBody = (createCourse, formValues, status) => {
    const body = createCourse
      ? createBundle !== "createBundle"
        ? {
          courseType: formValues.courseType,
          courseName: formValues.courseName,
          description: "",
          category: formValues.category,
          subCategory: formValues.subCategory,
          isAdult: formValues.IsAdult,
          status: status,
        }
        : {
          name: formValues.courseName,
          price: 2,
          coursesAdded: formValues.createBundle.map((ele) => ele.ID),
        }
      : storedSession === "liveCourse"
        ? {
          ...formValues,
          courseName: formValues.courseName,
          description: formValues.description
            ? formValues.description
            : "formValues.description",
          syllabus: [],
          preRequisites: [],
          courseSections: [],
          faqs: [],
          goals: [],
          status: status,
          preRequisites: [],
        }
        : createBundle === "createBundle"
          ? {
            name: formValues.courseName,
            price: formValues.enrollmentFee,
            description: formValues.description,
            imageLink: formValues.imageFiles[0],
            promoOffer: formValues.promotionalOffer,
            promoCode: formValues.promotionalCode,
            discountPercent: formValues.discountPercent,
            duration: formValues.duration,
            courses: formValues.createBundle.map((ele) => ele.ID),
            goals: formValues.goals,
            preRequisites:
              formValues.preRequisites[0].name === ""
                ? []
                : formValues.preRequisites,
            faqs: formValues.faqs,
            level: formValues.level,
            language: formValues.language,
            bundleOneLiner: formValues.courseOneLiner,
          }
          : {
            ...formValues,
            description: formValues.description
              ? formValues.description
              : "formValues.description",
            goals: formValues.goals.map((goal) => ({
              ...goal,
              courseId: getCourseId(location.state),
            })),
            courseSections: convertDesciptionToHtml(
              formValues.courseSections,
              getCourseId(location.state)
            ),
            imageFiles: [],
            videoFiles: [],
            step: current,
            status: status,
            preRequisites:
              formValues.preRequisites[0].name === ""
                ? []
                : formValues.preRequisites,
          };
    return JSON.stringify(body);
  };

  const getCourseId = (state) => {
    return state ? state.courseId : 0;
  };

  const Submit = async (status, createCourse = false) => {
    if (!createCourse) {
      setSubmit(true);
    }
    setLoaded(true);
    createUpdateCourse(
      createCourse,
      getRequestBody(createCourse, formValues, status),
      config,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      getCourseId(location.state)
    )
      .then(({ data }) => {
        if (!createCourse) {
          setLoaded(false);
          setSuccess(true);
          setResponse(data);
        } else {
          if (!data.error) {
            setLoaded(false);
            setResponse(data);
            navigate(
              `/dashboard/coursebuilder/${data.data?.id || data.data}`,
              {
                state: {
                  current:
                    createBundle === "createBundle"
                      ? 8
                      : storedSession === "liveCourse"
                        ? 9
                        : 8,
                  courseId: data.data?.id || data.data,
                  ...(createBundle === "createBundle" && {
                    courseSelected: formValues?.createBundle,
                  }),
                },
              }
            );

          }
        }
      })
      .catch((res) => console.log(res));
  };

  const handle = async ({ name, value }) => {
    if (name === "courseName" && createBundle !== "createBundle") {
      const validateCourseName = JSON.stringify({ courseName: value });

      try {
        const response = await axiosInstance.post("/course/name/validate", validateCourseName, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        setError(response?.data?.error);
      } catch (err) {
        console.error("Error validating course name:", err.message);
      }
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  const render = () => {
    if (storedSession === "liveCourse") {
      return 8;
    } else if (storedSession !== "liveCourse") {
      return 7;
    }
  };

  const quizSubmitHanlder = async () => {
    setCurrent(current + 1);
    setQuizResponse(false);

    try {
      const response = await axiosInstance.post("/quiz", quizCreation, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setQuizResponse(true);
      setQuizStatus(response.data.message);
    } catch (err) {
      console.error("Error submitting quiz:", err.message);
    }
  };


  return (
    <>
      <div id="courseBuilderWrapper">
        <div className="CourseBuilderSidebar">
          {/* {current > render() ? ( */}
          <CourseBuilderSidebar
            current={current}
            isValid={validate}
            formValues={formValues}
            storedSession={storedSession}
            setActiveSlide={setCurrent}
            coursebuilderToggle={coursebuilderToggle}
            setcoursebuilderToggle={setcoursebuilderToggle}
            location={createBundle}
          />
          {/* ) : (
            <></>
          )} */}
          <div className="CourseBuilderSidebar-right">
            {current === 3 ? (
              <></>
            ) : (
              <CourseBuilderTopbar handleExit={handleExit} current={current} />
            )}
            <form onSubmit={handleSubmit}>
              <div className="frame">
                <div className="box-container" ref={ref}>
                  {/* Course Questions */}
                  <CourseQuestion
                    handleInputChange={handle}
                    formValues={formValues}
                    next={next}
                    current={current}
                  />
                  {/* Course Category */}
                  <CourseCategory
                    handleInputChange={handle}
                    handleSelection={handleInputChange}
                    formValues={formValues}
                    error={error}
                    current={current}
                    storedSession={storedSession}
                    history={props.history}
                    setFormValues={setFormValues}
                    location={createBundle}
                  />
                  {/* Course Builder */}
                  <CourseBuilderMain
                    formValues={formValues}
                    handleInputChange={handleInputChange}
                    next={next}
                    quizValidateMsg={quizValidateMsg}
                    setQuizValidateMsg={setQuizValidateMsg}
                    validateDuplicateText={validateDuplicateText}
                    errors={errors}
                    addFormFields={addFormFields}
                    removeFormFields={removeFormFields}
                    current={current}
                    setQuizResponse={setQuizResponse}
                    setFormValues={setFormValues}
                    formState={formValues.courseDescription}
                    imageFiles={formValues.imageFiles}
                    Editvideo={formValues.videoFiles}
                    EditSection={formValues.courseSections}
                    history={props.history}
                    storedSession={storedSession}
                    quizCreation={quizCreation}
                    setQuizCreation={setQuizCreation}
                    quizResponse={quizResponse}
                    quizStatus={quizStatus}
                    coursebuilderToggle={coursebuilderToggle}
                    location={createBundle}
                  />
                </div>
              </div>
              <CourseBuilderFooter
                current={current}
                next={next}
                prev={prev}
                Submit={Submit}
                validate={validate}
                location={location}
                formValues={formValues}
                storedSession={storedSession}
                quizSubmitHanlder={quizSubmitHanlder}
                coursebuilderToggle={coursebuilderToggle}
                courseStatus={createBundle}
              />
            </form>
          </div>
        </div>
      </div>
      {saveDraft && (
        <SaveDraft
          handleClose={handleExit}
          Submit={Submit}
          current={current}
          formValues={formValues}
        />
      )}
      {submit && (
        <CourseSubmit
          closeHandler={closeHandler}
          loaded={loaded}
          success={success}
          response={response}
          submit={setSubmit}
          progressCount={progressCount}
        />
      )}
    </>
  );
};

export default CourseBuilder;





